import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  Typography,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
  Tooltip,
  Tabs,
  Tab
} from '@mui/material';
import { tokens } from "../../../../theme";
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import useApi from '../../../shared/hooks/useApi';
import * as XLSX from 'xlsx';
import CostReport from './CostReport';
import AfrrReservation from './AfrrReservation';

const Report = ({ setLoading, triggerAlert }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [reportData, setReportData] = useState([]);
  const [dateFrom, setDateFrom] = useState(dayjs().subtract(7, 'day'));
  const [dateTo, setDateTo] = useState(dayjs());
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [units, setUnits] = useState([]);
  const { apiGet } = useApi();
  const [tabValue, setTabValue] = useState(0);

  const fetchReportData = async () => {
    setLoading(true);
  
  };

  useEffect(() => {
    console.log("f -011 fetching report data");
    const getColumns = async () => {
      const response = await apiGet("UX_HTTP_API", `/esid-25-011/get-columns`);
      console.log("response", response);
    }
    getColumns();
  }, [dateFrom, dateTo]);

  const handleDownloadSingle = (row) => {
    try {
      let tempHeaders = [];
      let fileName = row[0];
      headers.map((header, index) => {
        units[index] !== "None"
          ? tempHeaders.push(header + (units[index] !== null ? "-" + units[index] : ""))
          : tempHeaders.push(header || "");
      });

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet([tempHeaders, row]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");
      // Write file
      XLSX.writeFile(wb, `report_${fileName}.xlsx`);
      triggerAlert("success", "Report downloaded successfully");
    } catch (error) {
      console.error('Error downloading single report:', error);
      triggerAlert("error", "Error downloading single report");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadAll = () => {
    try {
      let tempHeaders = [];
      headers.map((header, index) => {
        units[index] !== "None" ? tempHeaders.push(header + "-" + units[index]) : tempHeaders.push(header)
      });

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet([tempHeaders, ...rows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "All Reports");

      // Write file
      XLSX.writeFile(wb, `all_reports_${dateFrom.format('YYYY-MM-DD')}_${dateTo.format('YYYY-MM-DD')}.xlsx`);
      triggerAlert("success", "All reports downloaded successfully");
    } catch (error) {
      console.error('Error downloading all reports:', error);
      triggerAlert("error", "Error downloading all reports");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box m={4} ml={10}>
      <h1>Lummen Reports</h1>
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        sx={{ mb: 3 }}
      >
        <Tab label="Cost Report" />
        <Tab label="aFRR Report" />
        <Tab label="Captar Report" />

      </Tabs>

     {/*  {tabValue === 0 && (
        <CostReport colors={colors} reportData={reportData} headers={headers} rows={rows} units={units} dateFrom={dateFrom} dateTo={dateTo} setDateFrom={setDateFrom} setDateTo={setDateTo} handleDownloadAll={handleDownloadAll} handleDownloadSingle={handleDownloadSingle} />
      )}

      {tabValue === 1 && (
        <AfrrReservation colors={colors} setLoading={setLoading} triggerAlert={triggerAlert} handleDownloadAll={handleDownloadAll} handleDownloadSingle={handleDownloadSingle} />
      )} */}
    </Box>
  );
};

export default Report;